<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "DiseaseAndAccidentalBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "疾病/意外醫療保險",
        pageBlock: ["period", "formula", "maxCustom"],
        showUpper: true,
      },
      defaultForm: {
        unit_lower: 3,
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
